'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPlanet = function IoPlanet(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.5 20.8c3 1.9 6.6 3.7 10.5 5.4 3.4 1.5 6.8 2.7 9.8 3.6-2.1 1.7-4.8 2.7-7.8 2.7-6.6 0-12.1-5.2-12.5-11.7z m0.9-5.4c0-0.3 0.2-0.6 0.4-0.9 0.7-1.6 2-3.1 3.4-4.3 2.1-1.7 4.8-2.7 7.8-2.7 6.6 0 12.1 5.2 12.5 11.7v0.8c0 1.6-0.3 3.2-0.9 4.6 0 0.3-0.2 0.6-0.3 0.9-0.5-0.1-1.1-0.3-1.5-0.4-3.1-0.9-6.4-2.1-9.9-3.5-4.4-1.9-8.4-4.1-11.5-6.2z m25.2 6.9c4.4 2.7 6.8 4.8 6.3 6.4-0.3 0.9-1.5 1.3-3.4 1.3-3.9 0-10.6-1.8-18.1-5-11-4.8-19.2-10.9-18.3-13.7 0.3-0.9 1.5-1.5 3.4-1.3 1.7 0.2 3.7 0.7 5.7 1.4-0.6 0.7-0.6 0.9-1.1 1.7-1.8-0.4-3.4-0.6-4.6-0.6h-0.5c0.2 0.2 0.4 0.5 0.7 0.7 0.8 0.9 2.1 1.9 3.6 2.9 3.2 2.3 7.5 4.6 12.2 6.6 3.4 1.5 6.9 2.8 10 3.6 2.8 0.8 5.3 1.2 7 1.2h0.5c-0.2-0.2-0.4-0.5-0.7-0.7-0.8-0.8-1.8-1.7-3.2-2.7 0.3-0.8 0.4-0.9 0.5-1.8z' })
        )
    );
};

exports.default = IoPlanet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/planet.js
// module id = 2617
// module chunks = 0